import React from "react"
import _ from "lodash"
import styles from "./outline.module.scss"

export default (props) => (
  <aside className={styles.articleOutline}>
    <ul className={styles.outlineList}>
      {props.headings.map(heading => (
        <li className={styles.outlineListItem}>
          <a className={styles.outlineListItemLink} href={"#" + _.kebabCase(heading.value)}>
            {heading.value}
          </a>
        </li>
      ))}
    </ul>
  </aside>
)
